module.exports = __webpack_public_path__ + "static/media/piper-dialog3-desktop.6b2f8643.svg";